import { OptionsDTO } from '../../../src_server/entity/dto/OptionsDTO';


import { OptionalPaymentDTO } from '../../../src_server/entity/dto/OptionalPaymentDTO';


import { GeneratedBizBase } from '../GeneratedBizBase';


import { Response } from '../../../src_server/response/Response';


import { OptionalPayment } from '../../../src_server/entity/generated/OptionalPayment';export class PaymentOptionalService extends GeneratedBizBase{
  async getUsers(building_id: string): Promise<Response<OptionsDTO[]>> {
    return super.restCall<Response<OptionsDTO[]>>('get', '/v1/PaymentOptionalService/getUsers', arguments);
  }
  async getOptionalPayments(building_id: string,start_dt: string,end_dt: string): Promise<Response<OptionalPaymentDTO[]>> {
    return super.restCall<Response<OptionalPaymentDTO[]>>('get', '/v1/PaymentOptionalService/getOptionalPayments', arguments);
  }
  async addOptionalPayments(op: OptionalPayment): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/PaymentOptionalService/addOptionalPayments', arguments);
  }
  async editOptionalPayments(op: OptionalPayment): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/PaymentOptionalService/editOptionalPayments', arguments);
  }
  async deleteOptionalPayments(optional_payment_id: number): Promise<Response<number>> {
    return super.restCall<Response<number>>('post', '/v1/PaymentOptionalService/deleteOptionalPayments', arguments);
  }
}
